import type { WidgetId } from '@wix/members-area-app-definitions';
import type { FlowEditorSDK } from '@wix/yoshi-flow-editor';

import { MenuId } from '../../../constants';
import { removeMenuItemsByWidgetIds, updateMenuItemLabel } from './menu';

export const removeLoginBarMenuItems = async (
  editorSDK: FlowEditorSDK,
  widgetsIds: WidgetId[],
) => {
  return removeMenuItemsByWidgetIds(editorSDK, MenuId.LoginMenu, widgetsIds);
};

export const updateLoginBarMenuItemLabel = async (
  editorSDK: FlowEditorSDK,
  widgetId: WidgetId,
  newLabel: string,
) => {
  return updateMenuItemLabel({
    editorSDK,
    menuId: MenuId.LoginMenu,
    widgetId,
    newLabel,
  });
};
